/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getRoleListApi } from "../../services/_role";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";
import { errorToast, successToast } from "../../components/Toast";
import { getUserByIdApi, updateUserApi } from "../../services/_user";
import { StackHolder, UserType } from "../../components/Enums";
import { getSupplierNameListApi } from "../../services/_supplier";
import { getBuyerNameListApi } from "../../services/_buyer";
import { getAllChaApi } from "../../services/_cha";
import { getAllBrokerApi } from "../../services/_broker";
import { getAllLogisticApi } from "../../services/_logistic";
import { formatString } from "../../components/Helper";
import {
  editUserInitialValues,
  editStackHolderUserValidationSchema,
  editAdminUserValidationSchema,
} from "./UserFormHelper";

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);
  const [updateLoader, setUpdateLoader] = useState<boolean>(false);
  const [stackHolderNameList, setStackHolderNameList] = useState<any>([]);

  const [initialValues, setInitialValues] = useState(editUserInitialValues);
  const [validationSchema, setValidationSchema] = useState<any>();

  const getUserDetails = async () => {
    const result: any = await getUserByIdApi(id as string);
    if (result.isSuccess) {
      setInitialValues({
        user_type: result?.data?.user_type || UserType.ADMIN,
        stack_holder_type: result?.data?.stack_holder_type || "",
        stack_holder_id: result?.data?.stack_holder_id || "",
        role_id: result?.data?.role_id,
        name: result?.data?.name,
        email: result?.data?.email,
        phone_no: result?.data?.phone_no,
        status: result?.data?.status?.toString(),
      });
      if (result?.data?.user_type === UserType.STACK_HOLDER) {
        setValidationSchema(editStackHolderUserValidationSchema);
        if (result?.data?.stack_holder_type) {
          onChangeStackHolder(result?.data?.stack_holder_type);
        }
      } else {
        setValidationSchema(editAdminUserValidationSchema);
        getRoles();
      }
    }
  };

  const getRoles = async () => {
    const result: any = await getRoleListApi();
    if (result?.isSuccess) {
      setRoles(result.data);
    }
  };

  const onChangeStackHolder = async (stackHolder: any) => {
    if (stackHolder === StackHolder.SUPPLIER) {
      const result: any = await getSupplierNameListApi();
      if (result.isSuccess) {
        setStackHolderNameList(result?.data);
      }
    }
    if (stackHolder === StackHolder.BUYER) {
      const result: any = await getBuyerNameListApi();
      if (result.isSuccess) {
        setStackHolderNameList(result?.data);
      }
    }
    if (stackHolder === StackHolder.CHA) {
      const result: any = await getAllChaApi();
      if (result.isSuccess) {
        setStackHolderNameList(result?.data);
      }
    }
    if (stackHolder === StackHolder.BROKER) {
      const result: any = await getAllBrokerApi();
      if (result.isSuccess) {
        setStackHolderNameList(result?.data);
      }
    }
    if (stackHolder === StackHolder.FORWARDER) {
      const result: any = await getAllLogisticApi();
      if (result.isSuccess) {
        setStackHolderNameList(result?.data);
      }
    }
  };

  const handleSubmit = async (values: any) => {
    setUpdateLoader(true);
    const updatedValues = {
      ...values,
      status: values.status === "true",
    };
    const result: any = await updateUserApi(id as string, updatedValues);
    if (result.isSuccess) {
      successToast(result.message);
      setUpdateLoader(false);
      navigate(`/user-list?user_type=${values.user_type || UserType.ADMIN}`);
    } else {
      setUpdateLoader(false);
      errorToast(result.message);
    }
    return;
  };

  useEffect(() => {
    if (!id) {
      navigate("/user-list");
    } else {
      getUserDetails();
    }
  }, []);

  return (
    <>
      <div className="card">
        <div className="card-header pb-0">
          <div>
            <h5>Edit {formatString(initialValues.user_type)} User</h5>
          </div>
        </div>
        <div className="card-body">
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue, handleChange, resetForm }) => {
              return (
                <Form className="dt_adv_search">
                  <div className="row">
                    <div className="col-12">
                      <div
                        className="row g-3 ms-1 mb-2"
                        style={{ padding: "10px 5px 20px 5px" }}
                      >
                        {values.user_type === UserType.ADMIN && (
                          <>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="name"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Name: <span className="text-danger">*</span>
                              </label>
                              <Field
                                id="name"
                                name="name"
                                type="text"
                                className="form-control"
                                placeholder="Enter name"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="name"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="email"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Email: <span className="text-danger">*</span>
                              </label>
                              <Field
                                id="email"
                                name="email"
                                type="email"
                                className="form-control"
                                placeholder="Enter email"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="email"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="phone_no"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Phone No:
                              </label>
                              <Field
                                id="phone_no"
                                name="phone_no"
                                type="text"
                                className="form-control"
                                placeholder="Enter phone no"
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="role_id"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Role: <span className="text-danger">*</span>
                              </label>
                              <select
                                id="role_id"
                                name="role_id"
                                className="form-select"
                                onChange={handleChange}
                                value={values.role_id}
                              >
                                <option value="">Select Role</option>
                                {roles?.length &&
                                  roles.map((role: any) => (
                                    <option key={role.id} value={role.id}>
                                      {role.name}
                                    </option>
                                  ))}
                              </select>
                              <ErrorMessage
                                name="role_id"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="status"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Status: <span className="text-danger">*</span>
                              </label>
                              <select
                                id="status"
                                name="status"
                                className="form-select"
                                onChange={handleChange}
                                value={values?.status}
                              >
                                <option value="">Select Status</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </select>
                              <ErrorMessage
                                name="status"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={updateLoader}
                              >
                                {updateLoader && (
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                )}
                                Submit
                              </button>
                              <Link
                                to={"/user-list"}
                                type="button"
                                className="btn btn-label-github ms-5"
                              >
                                Back
                              </Link>
                            </div>
                          </>
                        )}

                        {values.user_type === UserType.STACK_HOLDER && (
                          <>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="stack_holder_type"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Stack Holder Type:{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                name="stack_holder_type"
                                id="stack_holder_type"
                                className="form-select"
                                value={values.stack_holder_type}
                                onChange={(e) => {
                                  resetForm({
                                    values: {
                                      ...editUserInitialValues,
                                      user_type: values.user_type,
                                    },
                                  });
                                  setFieldValue(e.target.name, e.target.value);
                                  onChangeStackHolder(e.target.value);
                                }}
                              >
                                <option value="">Select Stack Holder:</option>
                                {Object.values(StackHolder).map((type) => {
                                  return (
                                    <option value={type} key={type}>
                                      {formatString(type)}
                                    </option>
                                  );
                                })}
                              </select>
                              <ErrorMessage
                                name="stack_holder_type"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="stackHolderSelect"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Stack holder Name:{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                name="stack_holder_id"
                                id="stack_holder_id"
                                className="form-select"
                                value={values.stack_holder_id}
                                onChange={(e) => {
                                  handleChange(e);
                                  const stackHolderDetails =
                                    stackHolderNameList.find(
                                      (s: any) => s.id === e.target.value
                                    );
                                  setFieldValue(
                                    "name",
                                    stackHolderDetails?.name || ""
                                  );
                                  setFieldValue(
                                    "email",
                                    stackHolderDetails?.email || ""
                                  );
                                  setFieldValue(
                                    "phone_no",
                                    stackHolderDetails?.phone_no || ""
                                  );
                                }}
                              >
                                <option value="">
                                  Select Stack Holder Name:
                                </option>
                                {stackHolderNameList.map((stackHolder: any) => {
                                  return (
                                    <option
                                      value={stackHolder.id}
                                      key={stackHolder.name}
                                    >
                                      {formatString(stackHolder.name)}
                                    </option>
                                  );
                                })}
                              </select>
                              <ErrorMessage
                                name="stack_holder_id"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="email"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Email: <span className="text-danger">*</span>
                              </label>
                              <Field
                                id="email"
                                name="email"
                                type="email"
                                className="form-control"
                                placeholder="Enter email"
                                onChange={handleChange}
                                disabled
                              />
                              <ErrorMessage
                                name="email"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="phone_no"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Phone No:
                              </label>
                              <Field
                                id="phone_no"
                                name="phone_no"
                                type="text"
                                className="form-control"
                                placeholder="Enter phone no"
                                onChange={handleChange}
                                disabled
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-lg-4">
                              <label
                                htmlFor="status"
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Status: <span className="text-danger">*</span>
                              </label>
                              <select
                                id="status"
                                name="status"
                                className="form-select"
                                onChange={handleChange}
                                value={values?.status}
                              >
                                <option value="">Select Status</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </select>
                              <ErrorMessage
                                name="status"
                                className="text-danger"
                                component="div"
                              />
                            </div>
                            <div className="col-12">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={updateLoader}
                              >
                                {updateLoader && (
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                )}
                                Submit
                              </button>
                              <Link
                                to={`/user-list?user_type=${UserType.STACK_HOLDER}`}
                                type="button"
                                className="btn btn-label-github ms-5"
                              >
                                Back
                              </Link>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default EditUser;
